import type { Perfil, Tela } from '@bi-evox/contrato';
import type { NomeIcone } from '../components/Icone';

/** Abas do menu, na ordem de TELAS; o perfil de quem entrou diz quais aparecem. */
export const ABAS: { para: string; tela: Tela; rotulo: string; icone: NomeIcone }[] = [
  { para: '/', tela: 'visao-geral', rotulo: 'Visão geral', icone: 'visao' },
  { para: '/pagamentos', tela: 'pagamentos', rotulo: 'Pagamentos', icone: 'pagamentos' },
  { para: '/afiliados', tela: 'afiliados', rotulo: 'Afiliados', icone: 'afiliados' },
  { para: '/apostas', tela: 'apostas', rotulo: 'Apostas', icone: 'apostas' },
  { para: '/cassino', tela: 'cassino', rotulo: 'Cassino', icone: 'cassino' },
  { para: '/risco', tela: 'risco', rotulo: 'Risco esportivo', icone: 'risco' },
  { para: '/risco/evento', tela: 'risco', rotulo: 'Betlist do evento', icone: 'busca' },
  { para: '/saques', tela: 'saques', rotulo: 'Saques', icone: 'saques' },
  { para: '/jogadores', tela: 'jogadores', rotulo: 'Jogadores', icone: 'jogadores' },
  { para: '/niveis', tela: 'niveis', rotulo: 'Níveis', icone: 'niveis' },
  { para: '/conteudo', tela: 'conteudo', rotulo: 'Conteúdo do site', icone: 'conteudo' },
  { para: '/dados', tela: 'dados', rotulo: 'Dados', icone: 'dados' },
  { para: '/acessos', tela: 'acessos', rotulo: 'Acessos', icone: 'acessos' },
];

/** Telas sem aba (só API) também precisam de nome na tela Acessos. */
const SEM_ABA: Partial<Record<Tela, string>> = { portal: 'API da carteira do afiliado', atendimento: 'API de pagamentos e bilhetes do jogador' };

export const rotuloTela = (t: Tela) => ABAS.find((a) => a.tela === t)?.rotulo ?? SEM_ABA[t] ?? t;

export const ROTULO_PERFIL: Record<Perfil, string> = {
  admin: 'Admin',
  sportsbook: 'Sportsbook',
  cassino: 'Cassino',
  crm: 'CRM',
  afiliados: 'Afiliados',
  marketing: 'Marketing',
  portal: 'Carteira do afiliado (serviço)',
  atendimento: 'Copiloto do atendimento (serviço)',
};
